<div class="info-content-container">
  <div id="titleHeader" class="title-header flex-row">
    <span class="flex-1">{{ item.title }}</span>
    <button class="icon-button icon-close" (click)="goToGlossary()"></button>
  </div>
  <div class="scroll-container">
    <div class="content">
      <div class="information-container">
        <div class="statistics-title statistics-title--full">{{ "users.main.information" | translate }}</div>
        <div class="information-content">
          <div class="flex-row">
            <div class="flex-1 card-cell label-span">
              <label>{{ "glossary.item.title" | translate }}</label>
              <span>{{ item.title }}</span>
            </div>
            @if (isGermanEnabled) {
              <div class="flex-1 card-cell label-span">
                <label>{{ "glossary.item.titleDe" | translate }}</label>
                <span>{{ item.titleDe }}</span>
              </div>
            }
          </div>
          <div class="flex-row">
            <div class="flex-1 card-cell label-span">
              <label>{{ "glossary.item.description" | translate }}</label>
              <span [innerHTML]="item.description"></span>
            </div>
            @if (isGermanEnabled) {
              <div class="flex-1 card-cell label-span">
                <label>{{ "glossary.item.descriptionDe" | translate }}</label>
                <span [innerHTML]="item.descriptionDe"></span>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
